export function usePoligonoMap(poligono, concello = null) {
    const concelloConfig = concello
        ? {
              customLoader: () => {
                  return () => Promise.resolve(concello.geom);
              },
              detail: true,
          }
        : {customClickHandler: () => {}};

    const mapConfig = {
        concello: {...concelloConfig},
        poligono: {
            customLoader: () => {
                return () => Promise.resolve(poligono.geom);
            },
            detail: true,
        },
        subaglomeracion: {customClickHandler: () => {}},
        edar: {customClickHandler: () => {}},
        bombeo: {customClickHandler: () => {}},
        tanque: {customClickHandler: () => {}},
        colector: {
            visible: false,
            customClickHandler: () => {},
        },
        nucleo: {customClickHandler: () => {}},
    };

    return {mapConfig};
}
